export const INVEST_CHECKOUT = "INVEST_CHECKOUT";
export const INVEST_CHECKOUT_SUCCESS = "INVEST_CHECKOUT_SUCCESS";
export const INVEST_CHECKOUT_FAILED = "INVEST_CHECKOUT_FAILED";

export const CLEAR_INVEST_CHECKOUT_LOADING = "CLEAR_INVEST_CHECKOUT_LOADING";
export const CLEAR_INVEST_CHECKOUT_ERROR = "CLEAR_INVEST_CHECKOUT_ERROR";
